/**
 * CustomerProvisioning-PersonaCatalog.js
 *
 * Persona catalog for the Customer Provisioning tool.
 * Each entry maps a persona key to its category, display title,
 * default role, default character name, and classification.
 */

module.exports = [
  // ── Field ──────────────────────────────────────────────────
  {
    key: 'construction-inspector',
    category: 'Field',
    title: 'DOT Construction Inspector',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Marcus', last: 'Thompson' },
    classification: 'DOT',
  },
  {
    key: 'cei-field-inspector',
    category: 'Field',
    title: 'CEI Field Inspector',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Daniela', last: 'Reyes' },
    classification: 'CEI',
  },
  {
    key: 'materials-field-sampler',
    category: 'Field',
    title: 'Materials Field Sampler',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'James', last: 'Okafor' },
    classification: 'DOT',
  },
  {
    key: 'bridge-inspector',
    category: 'Field',
    title: 'Bridge Inspector',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Simon', last: 'Achebe' },
    classification: 'DOT',
  },
  {
    key: 'specialty-inspector-uas',
    category: 'Field',
    title: 'UAS Pilot / Specialty Inspector',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Alicia', last: 'Tran' },
    classification: 'DOT',
  },
  {
    key: 'contractor-field-representative',
    category: 'Field',
    title: 'Contractor Field Representative',
    role: 'UM-STD-R-CONTRACTOR',
    defaultName: { first: 'Ray', last: 'Dominguez' },
    classification: 'Contractor',
  },

  // ── Project Office ─────────────────────────────────────────
  {
    key: 'resident-engineer',
    category: 'Project Office',
    title: 'DOT Resident Engineer',
    role: 'UM-STD-R-PROJECT-MANAGER',
    defaultName: { first: 'Sarah', last: 'Nakamura' },
    classification: 'DOT',
  },
  {
    key: 'cei-project-manager',
    category: 'Project Office',
    title: 'CEI Project Manager',
    role: 'UM-STD-R-PROJECT-MANAGER',
    defaultName: { first: 'Kevin', last: 'Briggs' },
    classification: 'CEI',
  },
  {
    key: 'office-manager',
    category: 'Project Office',
    title: 'Field Office Manager',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Patricia', last: 'Goodwin' },
    classification: 'DOT',
  },
  {
    key: 'lab-technician',
    category: 'Project Office',
    title: 'Lab Technician',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Tyler', last: 'Marsh' },
    classification: 'DOT',
  },
  {
    key: 'project-engineer-eit',
    category: 'Project Office',
    title: 'Project Engineer / Engineer-in-Training',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Mei', last: 'Chen' },
    classification: 'DOT',
  },
  {
    key: 'local-agency-inspector',
    category: 'Project Office',
    title: 'Local Agency Inspector/PM',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Derek', last: 'Washington' },
    classification: 'Local Agency',
  },

  // ── Back Office ────────────────────────────────────────────
  {
    key: 'materials-lab-manager',
    category: 'Back Office',
    title: 'Materials Lab Manager',
    role: 'UM-STD-R-PROJECT-MANAGER',
    defaultName: { first: 'Carol', last: 'Hensley' },
    classification: 'DOT',
  },
  {
    key: 'contract-administrator',
    category: 'Back Office',
    title: 'Contract Administrator',
    role: 'UM-STD-R-PROJECT-MANAGER',
    defaultName: { first: 'Robert', last: 'Kimani' },
    classification: 'DOT',
  },
  {
    key: 'program-director',
    category: 'Back Office',
    title: 'Program Director',
    role: 'UM-STD-R-HL-ADMIN',
    defaultName: { first: 'Denise', last: 'Whitmore' },
    classification: 'DOT',
  },
  {
    key: 'it-system-administrator',
    category: 'Back Office',
    title: 'IT / System Administrator',
    role: 'UM-STD-R-HL-ADMIN',
    defaultName: { first: 'Raj', last: 'Patel' },
    classification: 'DOT',
  },
  {
    key: 'dbe-compliance-officer',
    category: 'Back Office',
    title: 'DBE / Civil Rights Compliance Officer',
    role: 'UM-STD-R-HL-USER',
    defaultName: { first: 'Angela', last: 'Torres' },
    classification: 'DOT',
  },
  {
    key: 'cei-firm-executive',
    category: 'Back Office',
    title: 'CEI Firm Executive / Division Director',
    role: 'UM-STD-R-PROJECT-MANAGER',
    defaultName: { first: 'Christine', last: 'Park' },
    classification: 'CEI',
  },
];
